import { SimpleBase } from './SimpleBase';
import { Base } from './Base';

export class ArrayBase extends SimpleBase {
  static create() {
    return [];
  }

  static isValidType(target) {
    return Array.isArray(target);
  }

  static isValid(target) {
    return this.isValidType(target) && target.length > 0;
  }

  static count(target) {
    if (Array.isArray(target)) {
      return target.length;
    }
    return 0;
  }

  static isEqual(a, b) {
    const eq = Base.isEqual(a, b);
    if (eq !== undefined) {
      return eq;
    }
    return JSON.stringify(a.sort()) === JSON.stringify(b.sort());
  }
}
